<div
    class="anc-field anc-file-upload"
    [class.anc-field--floating]="!!label()"
    [class.anc-field--focused]="focused()"
    [class.anc-file-upload--disabled]="disabled()"
    [class.anc-file-upload--drag-over]="dragOver()"
>
    <div
        class="anc-file-upload__zone"
        (click)="onZoneClick($event)"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
    >
        <div class="anc-file-upload__value">
            <label
                class="anc-file-upload__filename"
                [attr.for]="resolvedInputId()"
                [title]="selectedFileName()"
            >
                @if (selectedFileName()) {
                    {{ selectedFileName() }}
                }
            </label>
            <input
                #fileInput
                class="anc-file-upload__input"
                type="file"
                [id]="resolvedInputId()"
                [accept]="accept()"
                [attr.multiple]="multiple() ? '' : null"
                [disabled]="disabled()"
                (change)="onFileInputChange($event)"
            />
        </div>
        <button
            type="button"
            class="anc-file-upload__browse"
            [disabled]="disabled()"
            (click)="onBrowseClick($event)"
            translate
        >
            {{ browseLabel() }}
        </button>
    </div>

    @if (label()) {
        <label class="anc-field__label" translate>
            {{ label() }}<sup class="super-star" *ngIf="required()">*</sup>
        </label>
    }
</div>

@if (selectedFileName()) {
    <div class="anc-file-upload__chip">
        <span class="anc-file-upload__chip-name" [title]="selectedFileName()">
            {{ selectedFileName() }}
        </span>
        <button
            type="button"
            class="anc-file-upload__chip-clear icon icon-close"
            [disabled]="disabled()"
            [attr.aria-label]="'Remove file'"
            (click)="onClearClick($event)"
        ></button>
    </div>
}
